import { render, staticRenderFns } from "./BaseProfileLoader.vue?vue&type=template&id=306a0f34&scoped=true"
import script from "./BaseProfileLoader.vue?vue&type=script&lang=js"
export * from "./BaseProfileLoader.vue?vue&type=script&lang=js"
import style0 from "./BaseProfileLoader.vue?vue&type=style&index=0&id=306a0f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306a0f34",
  null
  
)

export default component.exports